import { c as _c } from "react/compiler-runtime";
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { useEffect, useState } from 'react';
import Frame, { FrameContextConsumer } from 'react-frame-component';
import useMediaQuery from 'shared/hooks/use-media-query';
import { getEmailEditorUrl } from 'shared/utils/get-email-editor-url';
import { twJoin } from 'tailwind-merge';
import { ExtendedState } from '../../types/common';
import { FontFamilyEnum } from '@systemeio/tip-tap';
export type NewEditorProps = {
  tempState: ExtendedState;
  isPreFetching?: boolean;
  mailingId: MailingId;
  disabled?: boolean;
};
export const NewEditor = t0 => {
  const $ = _c(12);
  const {
    tempState,
    isPreFetching,
    mailingId,
    disabled
  } = t0;
  const [height, setHeight] = useState(0);
  const {
    isLG
  } = useMediaQuery();
  const t1 = isLG ? height : "inherit";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      height: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = (isPreFetching || disabled) && "pointer-events-none";
  let t4;
  if ($[2] !== t3) {
    t4 = twJoin("w-full", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = disabled ? -1 : undefined;
  let t6;
  if ($[4] !== mailingId || $[5] !== tempState) {
    t6 = <FrameContextConsumer>{t7 => {
        const {
          document
        } = t7;
        return <FrameContent document={document} setHeight={setHeight} tempState={tempState} mailingId={mailingId} />;
      }}</FrameContextConsumer>;
    $[4] = mailingId;
    $[5] = tempState;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <Frame style={t2} className={t4} tabIndex={t5}>{t6}</Frame>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
interface FrameContentProps extends Pick<NewEditorProps, 'tempState' | 'mailingId'> {
  document?: Document;
  setHeight: (height: number) => void;
}
const FrameContent = t0 => {
  const $ = _c(17);
  const {
    tempState,
    mailingId,
    setHeight,
    document
  } = t0;
  let t1;
  if ($[0] !== document?.body.clientHeight || $[1] !== setHeight) {
    t1 = () => {
      const height = document?.body.clientHeight;
      if (!height) {
        return;
      }
      setHeight(height);
    };
    $[0] = document?.body.clientHeight;
    $[1] = setHeight;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== document || $[4] !== setHeight) {
    t2 = [document, setHeight];
    $[3] = document;
    $[4] = setHeight;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== mailingId) {
    t4 = getEmailEditorUrl(mailingId);
    $[7] = mailingId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <a style={t3} target="_parent" href={t4} />;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      fontFamily: FontFamilyEnum.Arial
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = tempState.html ?? "";
  let t8;
  if ($[12] !== t7) {
    t8 = <div style={t6} dangerouslySetInnerHTML={{
      __html: t7
    }} />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};